/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Point1Inputs */

const en_dr_why_point1 = /** @type {(inputs: Dr_Why_Point1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoconferencing suppresses idea generation but not selection (Brucks & Levav 2022, Nature) — so generation stays async and individual; only selection happens live.`)
};

const id_dr_why_point1 = /** @type {(inputs: Dr_Why_Point1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoconference menekan pembangkitan ide tapi tidak menekan seleksi (Brucks & Levav 2022, Nature) — jadi pembangkitan ide tetap asinkron & individual, hanya seleksi yang boleh berlangsung serentak.`)
};

/**
* | output |
* | --- |
* | "Videoconferencing suppresses idea generation but not selection (Brucks & Levav 2022, Nature) — so generation stays async and individual; only selection happe..." |
*
* @param {Dr_Why_Point1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_point1 = /** @type {((inputs?: Dr_Why_Point1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Point1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_point1(inputs)
	return en_dr_why_point1(inputs)
});